import { MAX_PIN_LENGTH } from '@/consts';
import { checkSessionAndRedirect, tryPinCheck } from '@/core/presenter/controller/LoginController';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as ViewModel from '@/core/presenter/viewModel';
import { trySendAsset, trySendTrx } from '@/core/presenter/controller/HomeController';
import { encryptPassword } from '@/core/domain/usecases/passwordUsecase';

// Location state 타입 정의
interface LocationState {
  returnPath?: string;
  isSendView?: boolean;
  sendData?: {
    address: string;
    asset: string;
    selectedAsset?: ViewModel.IAsset;
    assetSymbol?: string;
  };
  userId?: string;
  userPhone?: string;
  from?: string;
  to?: string;
  amount?: number;
  memo?: string;
}

export default function usePin() {
  const [pin, setPin] = useState<string>('');
  const [isPinCheckFailed, setIsPinCheckFailed] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  // location.state의 타입을 LocationState로 타입 단언
  const state = location.state as LocationState;

  useEffect(() => {
    const checkAuth = async () => {
      await checkSessionAndRedirect();
    };
    checkAuth();
  }, []);

  /** 숫자 버튼 클릭 이벤트 */
  const onClickNumberBtn = useCallback(
    async (number: string) => {
      if (pin.length < MAX_PIN_LENGTH) {
        const newPin = pin + number;
        setPin(newPin);

        if (newPin.length === MAX_PIN_LENGTH) {
          const userId = state?.userId || '';
          const encryptedPin = await encryptPassword(state.userPhone ?? '', newPin);
          const isSuccess = await tryPinCheck(userId, encryptedPin);

          if (isSuccess.succed) {
            if (state?.sendData?.assetSymbol === ViewModel.AssetType.DBS) {
              await trySendAsset({
                id: userId,
                phone: state?.userPhone ?? '',
                from: state?.from ?? '',
                to: state?.to ?? '',
                amount: state?.amount ?? 0,
                memo: state?.memo ?? '',
              });
            } else {
              await trySendTrx({
                id: userId,
                phone: state?.userPhone ?? '',
                from: state?.from ?? '',
                to: state?.to ?? '',
                amount: state?.amount ?? 0,
                memo: state?.memo ?? '',
              });
            }
            setTimeout(() => {
              if (state?.returnPath) {
                navigate(state.returnPath, {
                  state: {
                    isSendView: state?.isSendView,
                    sendData: state?.sendData,
                  },
                  replace: true,
                });
              } else {
                navigate('/home', { replace: true });
              }
            }, 0);
          } else {
            setIsPinCheckFailed(true);
            setPin('');
          }
        }
      }
    },
    [pin, navigate, state],
  );

  /** 삭제 버튼 클릭 이벤트 */
  const OnClickDeleteBtn = useCallback(() => {
    setPin(pin.slice(0, -1));
  }, [pin]);

  /** 전체 삭제 버튼 클릭 이벤트 */
  const onClickAllClearBtn = useCallback(() => {
    setPin('');
  }, []);

  return {
    pin,
    isPinCheckFailed,
    onClickNumberBtn,
    OnClickDeleteBtn,
    onClickAllClearBtn,
  };
}
